import React, { ReactElement } from 'react';
import { Checkbox } from '@mui/material';
import { StyledMediumTypography, StyledRowBox } from '../../theme/StyledElements';
import { useTranslation } from 'react-i18next';
import { TimePickerCustom } from './TimePickerCustom';
import { getCheckedImage } from '../../utils';

interface SelectTimeComponentProps {
    modify: boolean | undefined;
    checked: boolean | undefined;
    startTime: string | undefined;
    lastTime: string | undefined;
    onCheckedChange: Function;
    onStartTimeChange: Function;
    onLastTimeChange: Function;
}

export function SelectTimeComponent({
    modify,
    checked,
    startTime,
    lastTime,
    onCheckedChange,
    onStartTimeChange,
    onLastTimeChange
}: SelectTimeComponentProps): ReactElement {
    const { t } = useTranslation();

    return (
        <StyledRowBox key={1}>
            {modify ? (
                <Checkbox
                    id="checked"
                    name="checked"
                    checked={checked}
                    onChange={(event): void => onCheckedChange(event.target.checked)}
                    sx={{
                        color: '#E37F1E',
                        '&.Mui-checked': {
                            color: '#E37F1E'
                        }
                    }}
                />
            ) : (
                getCheckedImage(checked)
            )}
            <TimePickerCustom
                modify={modify}
                time={startTime}
                onTimeChange={(value: string): void => onStartTimeChange(value)}
            />
            <StyledMediumTypography variant="body1" sx={{ padding: '20px' }}>
                {t('at')}
            </StyledMediumTypography>
            <TimePickerCustom
                modify={modify}
                time={lastTime}
                onTimeChange={(value: string): void => onLastTimeChange(value)}
            />
        </StyledRowBox>
    );
}
